import React from "react"
import discordButtonStyle from "./discordButton.module.css"

const DiscordButton = (props, data) => {
    return (
        <div className={discordButtonStyle.discordButton}>
            <a href="https://discord.gg/8cpkWyn78Y" target="_blank" style={{textDecoration:"none"}}>
                <button>
                    <div style={{display:"grid", gridAutoFlow:"column", gap:"5px", justifyContent:"center"}}><i class={"ri-discord-line"}></i> Join our Discord for more help!</div>
                </button>
            </a>
        </div>
    )
}

export default DiscordButton;
